import React, { Component } from 'react'
import request from "../../lib/requester";
import _, { toNumber } from "lodash";
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from 'moment';
import xlsx from 'xlsx';
import { warning } from '../../component/modal/success';

class UploadDocument extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileRequired: {
        filename: '',
        path: ''
      },
      dataTable: [],
      lovPrincipal: [],
      containerFile: [],
      selectedOrgId: '',
      selectedOrgInitial: '',
      success: '',
      error: [],
      is_submitted: false,
      user: JSON.parse(window.localStorage.getItem('is_user')),
      temporaryFile: ''
    }
  }

  componentDidMount = () => {
    this.getPrincipal()
  }

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  removeFile = () => {
    let { fileRequired } = this.state
    fileRequired.filename = ''
    fileRequired.path = ''
    this.setState(fileRequired)
  }

  renderFileUpload = () => {
    return (
      <div className="row">
        <div className="col-md-3">
          <input type="file" className="form-control" id="upload-program-file" onChange={this.handleUploadSingle.bind(this)} />
        </div>
        <div className="col-md-3">
          <select className="form-control" name="principal" onChange={this.handleChangePrincipal.bind(this)}>
            <option value="">- Select Principal -</option>
            {
              this.state.lovPrincipal.map((item, index) => (
                <option value={item.org_id}>{item.org_name}</option>
              ))
            }
          </select>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary btn-block" type="button" onClick={this.handleSubmit.bind(this)} ><i className="fa fa-save" /> Submit</button>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary btn-warning btn-block" type="button"
            onClick={() => {
              this.setState({ dataTable: [] })
              document.getElementById('upload-program-file').value = null
            }} ><i className="fa fa-undo" /> Reset</button>
        </div>
      </div>
    )
  }

  renderFormUpload = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              {this.renderFileUpload()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  validationForm = () => {
    let error = []
    let { potong_pajak, fileRequired } = this.state
    if (fileRequired.filename.length === 0) {
      error.push('File is required')
    }
    if (error.length > 0) {
      this.setState({ error: error })
      return false
    } else {
      return true
    }
  }

  checkValidDates = (array) => {
    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      const values = Object.values(obj);
      if (values.includes("Invalid date")) {
        return false;
      }
    }
    return true;
  }

  handleSubmit = async () => {
    if (this.state.selectedOrgId.length === 0) {
      alert('Please select Principal')
      return false
    }

    if (this.state.dataTable.length === 0) {
      alert('No data program')
      return false
    }

    if (!this.checkValidDates(this.state.dataTable)) {
      alert('Invalid date format. Please read note on header excel file.')
      return false
    }

    if (window.confirm('Are you sure to submit all this program?')) {
      let url = '/api/traces/v1/program/bulk-program'
      let param = {
        data: this.state.dataTable,
        org_id: this.state.selectedOrgId,
        user_id: this.state.user.user_id,
        org_initial: this.state.selectedOrgInitial
      }
      this.setState({ loading: true })
      request.postTraces(url, param, {
        success: async function (response) {
          try {
            const timestamp = moment().unix()
            let filename = this.state.temporaryFile.name
            const splitName = filename.split('.')
            var fileExt = filename.split(".").pop()
            const final = `${splitName[0]}-${timestamp}.${fileExt}`

            const fileNameToMinio = `/excel-multiupload-program/${final}`;
            const minioUrl = await request.createPresignedUrl(fileNameToMinio);
            const uploadFilePdf = await request.uploadToS3(minioUrl, this.state.temporaryFile);

            if (uploadFilePdf?.status === 204) {
              this.setState({ loading: false, success: 'All programs has been submitted' })
              window.scrollTo(0, 0)

              window.setTimeout(() => {
                document.getElementById('home-tab').classList.remove('active');
                document.getElementById('profile-tab').classList.add('active');

                document.getElementById('home').classList.remove('show', 'active')
                document.getElementById('profile').classList.add('active', 'show')
              }, 3000)
            } else {
              warning('Failed', 'Gagal upload file')
            }
            this.setState({ loading: false });
          } catch (error) {
            console.log("masuk di error : ", error)
            this.setState({ loading: false });
          }
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false, error: [e.response.data.message || 'Failed submit program'] })
          window.scrollTo(0, 0)
        }.bind(this)
      })
    }
  }

  handleInputChange = (e) => {
    let name = e.target.name
    let value = e.target.value

    this.setState({ [name]: value })
  }

  handleUploadSingle = async (e) => {
    if (e.target.files && e.target.files.length) {

      const file = e.target.files[0];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const reader = new FileReader();

      const timestamp = moment().unix()
      let filename = file.name;
      const splitName = filename.split('.')
      var fileExt = filename.split(".").pop()
      const final = `${splitName[0]}-${timestamp}.${fileExt}`

      this.setState({ loading: true, temporaryFile: file });
      // Mengecek ekstensi file
      if (fileExtension === 'xlsx') {
        reader.onload = async (e) => {
          var data = e.target.result;
          let readedData = xlsx.read(data, {
            type: "binary",
            cellDates: true,
            cellNF: false,
            cellText: false,
          });

          const wsname = readedData.SheetNames[1];
          const ws = readedData.Sheets[wsname];
          const worksheetProgram = xlsx.utils.sheet_to_json(ws, {
            header: 0,
            raw: false,
            defval: null,
            dateNF: 'yyyy-mm-dd'
          });
          const wsname2 = readedData.SheetNames[2];
          const ws2 = readedData.Sheets[wsname2];
          const worksheetDocument = xlsx.utils.sheet_to_json(ws2, {
            header: 0,
            raw: false,
            defval: null,
            dateNF: 'yyyy-mm-dd'
          });
          const wsname3 = readedData.SheetNames[3];
          const ws3 = readedData.Sheets[wsname3];
          const worksheetUpload = xlsx.utils.sheet_to_json(ws3, {
            header: 0,
            raw: false,
            defval: null,
            dateNF: 'yyyy-mm-dd'
          });

          let containerProgram = []
          worksheetProgram.map((value, index) => {
            containerProgram.push({
              ref_number: value["SKP NO"],
              start_date: moment(value["START DATE"]).format("YYYY-MM-DD"),
              end_date: moment(value["END DATE"]).format("YYYY-MM-DD"),
              claim_exp_date: moment(value["CLAIM EXPIRED DATE"]).format("YYYY-MM-DD"),
              program_type: value["PROGRAM TYPE"],
              program_type_id: value["PROGRAM_TYPE_ID"],
              description: value["PROGRAM DESCRIPTION"],
              budget_type: value["BUDGET TYPE"],
              budget_type_id: value["BUDGET TYPE ID"],
              budget: value["BUDGET AMOUNT"],
              sales_target: value["SALES TARGET AMOUNT"],
              pph_type: value["CUSTOMER PPH TYPE"],
              pph_rate: value["CUSTOMER PPH RATE"],
              participant_type: value["PARTICIPANT TYPE"],
              program_member_id: value["PARTICIPANT TYPE ID"],
              branch: value["Branch"],
              branch_id: value["BRANCH ID"],
              participant: value["Participant"],
              total_participant: value["TOTAL PARTICIPANT"],
              notes: value["NOTES PARTICIPANT"],
              document_list: [],
              user_name: "SYSTEM",
              function: "create",
              menu: "Upload Program",
              source: "arman",
              product_list: [
                {
                  item_id: "0",
                  item_desc: "ALL PRODUCTS",
                  item_reff: "",
                  item_budget: 0,
                },
              ],
              document_upload: {},
            })
          })

          // Loop through worksheetDocument
          for (let doc of worksheetDocument) {
            const refNumber = doc['SKP NO'];

            // Find the corresponding element in containerProgram
            const program = containerProgram.find(program => program['ref_number'] === refNumber);
            if (program) {
              // Add documentId to document_list in program
              const documentId = doc['DOCUMENT  CLAIM']; // Mengganti "DOCUMENT CLAIM" dengan "DOCUMENT  CLAIM" untuk sesuai dengan properti di worksheetDocument
              program['document_list'].push({ documentId });
            }
          }

          // Loop through worksheetUpload
          for (let upload of worksheetUpload) {
            const refNumber = upload['SKP NO'];

            // Find the corresponding element in containerProgram
            const program = containerProgram.find(program => program['ref_number'] === refNumber);

            if (program) {
              // Add filename and fullurl to document_upload in program
              const fileName = upload['FILE NAME'];
              program['document_upload'] = {
                filename: fileName,
                fullurl: `/api/traces/files/${fileName}`
              };
            }
          }
          console.log('containerProgram : ', containerProgram);
          this.setState({
            dataTable: containerProgram,
            loading: false
          })
        };
      } else if (fileExtension === 'xls') {
        this.setState({ loading: false });
        warning('Failed', 'File tidak suport. Silahkan rubah extention menjadi Microsoft Excel Workbook (.xlsx)')
      } else {
        this.setState({ loading: false });
        warning('Failed', 'File tidak suport.')
      }

      reader.readAsBinaryString(file);
    }
  };

  // handleUploadSingle = async (e) => {
  //   if (e.target.files.length === 0) {
  //     return false;
  //   }

  //   let file = e.target.files[0];
  //   // validation
  //   const timestamp = moment().unix()
  //   let filename = file.name;
  //   const splitName = filename.split('.')
  //   var fileExt = filename.split(".").pop()
  //   const final = `${splitName[0]}-${timestamp}.${fileExt}`

  //   var allowedFile = ["xlsx", "xls"];
  //   if (allowedFile.indexOf(fileExt) < 0) {
  //     this.setState({ error: ["File extension not allowed"] });
  //     document.body.scrollTop = document.documentElement.scrollTop = 0;
  //     return false;
  //   }

  //   const data = new FormData();
  //   data.append("myFile", file, file.name);
  //   this.setState({ loading: true });

  //   try {
  //     const fileNameToMinio = `/excel-multiupload-program/${final}`;
  //     const minioUrl = await request.createPresignedUrl(fileNameToMinio);
  //     const uploadFilePdf = await request.uploadToS3(minioUrl, file);

  //     if (uploadFilePdf?.status === 204) {
  //       request.postTraces('/api/traces/v1/program/read-files', { filename: final }, {
  //         success: function (response) {
  //           let { data } = response.data
  //           this.setState({ loading: false, dataTable: data });
  //         }.bind(this),
  //         error: function (e) {
  //           this.setState({ loading: false });
  //         }.bind(this)
  //       })
  //     } else {
  //       console.log("masuk di else ")
  //     }
  //     this.setState({ loading: false });
  //   } catch (error) {
  //     console.log("masuk di error : ", error)
  //     this.setState({ loading: false });
  //   }
  // };

  renderTable = () => {
    if (this.state.dataTable.length > 0) {
      const data = {
        columns: [
          {
            Header: "REF NO",
            accessor: "ref_number",
            filterable: false,
          },
          {
            Header: "START DATE",
            accessor: "start_date",
            filterable: false,
            Cell: (row) => (
              <span>{row.value ? moment(row.value).format('DD-MMM-YYYY') : ''}</span>
            )
          },
          {
            Header: "END DATE",
            accessor: "end_date",
            filterable: false,
            Cell: (row) => (
              <span>{row.value ? moment(row.value).format('DD-MMM-YYYY') : ''}</span>
            )
          },
          {
            Header: "CLAIM EXP DATE",
            accessor: "claim_exp_date",
            filterable: false,
            Cell: (row) => (
              <span>{row.value ? moment(row.value).format('DD-MMM-YYYY') : ''}</span>
            )
          },
          {
            Header: "PROGRAM TYPE",
            accessor: "program_type",
            filterable: false,
          },
          {
            Header: "PROGRAM DESCRIPTION",
            accessor: "description",
            filterable: false,
          },
          {
            Header: "BUDGET TYPE",
            accessor: "budget_type",
            filterable: false,
          },
          {
            Header: "BUDGET AMOUNT",
            accessor: "budget",
            filterable: false,
          },
          {
            Header: "SALES TARGET",
            accessor: "sales_target",
            filterable: false,
          },
          {
            Header: "PPH TYPE",
            accessor: "pph_type",
            filterable: false,
          },
          {
            Header: "PPH RATE",
            accessor: "pph_rate",
            filterable: false,
          },
          {
            Header: "PARTICIPANT TYPE",
            accessor: "participant_type",
            filterable: false,
          },
          {
            Header: "BRANCH",
            accessor: "branch",
            filterable: false,
          },
          {
            Header: "PARTICIPANT",
            accessor: "participant",
            filterable: false,
          },
          {
            Header: "TOTAL PARTICIPANT",
            accessor: "total_participant",
            filterable: false,
          },
          {
            Header: "NOTES",
            accessor: "notes",
            filterable: false,
          },
        ],
        rows: this.state.dataTable,
      };
      return (
        <ReactTable
          className="fullWidth"
          data={data.rows}
          columns={data.columns}
          defaultPageSize={10}
          defaultFilterMethod={(filter, row, column) => {
            let columnes = row[filter.id];
            return columnes
              ? columnes.toLowerCase().includes(filter.value.toLowerCase())
              : "";
          }}
        />
      );
    }
  }

  handleChangePrincipal = (e) => {
    let value = e.target.value
    let find = _.find(this.state.lovPrincipal, (o) => {
      return parseInt(o.org_id) === parseInt(value)
    })

    let org_initial = find ? find.org_initial : ''
    this.setState({ selectedOrgId: value, selectedOrgInitial: org_initial })
  }

  renderFormUploadPDF = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning">
                <ul>
                  <li><i className="fa fa-exclamation-triangle" /> To multiple upload use CTRL + Click</li>
                  <li><i className="fa fa-exclamation-triangle" /> Allowed file extension: PDF</li>
                </ul>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <input type="file" className="form-control" multiple name="imagesArray" accept=".pdf" onChange={this.handleUploadMultiple.bind(this)} />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <button type="button" className="btn btn-success btn-block" onClick={this.handleUploadSKP.bind(this)}><i className="fa fa-upload" /> Upload</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleUploadMultiple = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files;
    this.setState({ containerFile: files })
  }

  handleUploadSKP = () => {
    const data = new FormData();
    let { containerFile } = this.state

    for (const key of Object.keys(containerFile)) {
      data.append('filesUpload', containerFile[key])
    }

    this.setState({ loading: true });
    request.postnobodyTraces("/api/traces/v1/general/upload-file-multi", data, {
      success: function (response) {
        let data = response.data;
        this.setState({ loading: false, success: 'All files has been uploaded' })
        window.scrollTo(0, 0)
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false, error: ['Failed to upload SKP'] });
        console.log(e.message)
      }.bind(this),
    });
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-body">
                      {this.showNotification()}
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link active font-weight-bold" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true"><i className="fa fa-file" /> Upload Program</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link font-weight-bold" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"><i className="fa fa-file" /> Upload SKP</a>
                        </li>
                      </ul>
                      <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active p-3" id="home" role="tabpanel" aria-labelledby="home-tab">
                          {this.renderFormUpload()}
                          {this.renderTable()}
                        </div>
                        <div class="tab-pane fade p-3" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                          {this.renderFormUploadPDF()}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default UploadDocument